import { defineComponent as _defineComponent } from 'vue'
import { faPlay } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowCTA',
  props: {
    isHighlighted: { type: Boolean },
    hasPromotionTag: { type: Boolean },
    fullWidth: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,faPlay }
}

})